<template>
    <Paper class="p-4">
        <h6 class="subtitle font-weight-bold">
            {{ $t('tests.cute.logoCarousel.header') }}
        </h6>
        <div
            class="carousel-wrapper"
            style="display:block;margin:auto;max-width:630px;"
        >
            <Carousel
                style="width:100%"
                :component="getComponent()"
                :items="items"
            />
        </div>
    </Paper>
</template>

<script>
// Components
import CompanyItem from './Carousel.Item';

// Assets
import companyLogos from '../data/cuteCompanies.json';

export default {
    name: 'CompanyCarousel',
    data: () => ({
        items: companyLogos,
    }),
    methods: {
        getComponent() {
            return CompanyItem;
        },
    },
};
</script>

<style scoped>
@media only screen and (max-width: 750px) {
    .carousel-wrapper {
        max-width: 550px !important;
    }
}

@media only screen and (max-width: 600px) {
    .carousel-wrapper {
        max-width: 200px !important;
    }
}
</style>
